<template>
  <BaseButton
    v-hotkey="shortcuts"
    class="icon"
    kind="auxiliary"
    :tooltip="{
      text: isLeftPaneShown ? 'Collapse' : 'Expand',
      shortcut: togglePaneActions.leftPane.shortcutsDisplay,
    }"
    tooltip-display="always"
    @click="toggle"
  >
    <template #icon>
      <SidebarIcon />
    </template>
  </BaseButton>
</template>
<script lang="ts">
import { computed, defineComponent, toRefs, inject as vueInject } from "vue";

import { togglePaneActions } from "@/components/actions/actions";
import BaseButton from "@/components/base/BaseButton.vue";
import SidebarIcon from "@/components/icons/SidebarIcon.vue";
import * as inject from "@/components/inject";
import { keyUseLeftPane } from "@/components/planner/controllers/planner";

import { assignShortcuts, Shortcuts, toggleLeftPane } from "../shortcuts";

export default defineComponent({
  components: {
    BaseButton,
    SidebarIcon,
  },
  props: {
    isHideable: { type: Boolean, default: true },
  },
  setup(props) {
    const { isHideable } = toRefs(props);
    const isInputFocused = inject.isInputFocused();
    const isModalShown = inject.isModalShown();
    const useLeftPane = isHideable.value ? vueInject(keyUseLeftPane) : null;
    const toggle = () => {
      if (useLeftPane?.isLeftPaneShown.value) useLeftPane.hideLeftPane();
      else useLeftPane?.showLeftPane();
    };
    const isLeftPaneShown = computed(() => useLeftPane?.isLeftPaneShown.value);
    const shortcuts = computed<Shortcuts>(() => {
      return {
        ...assignShortcuts(
          { isModalShown, isInputFocused },
          toggleLeftPane,
          toggle
        ),
      };
    });
    return {
      shortcuts,
      toggle,
      togglePaneActions,
      isLeftPaneShown,
    };
  },
});
</script>
